// src\themes\lino\elements\Product\SwiperRelatedProducts.tsx
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/pagination";
import { MainShopProduct } from "@/core/models/shop-product-model";
import { loadThemeComponent } from "@/core/config/theme-component-loader";

type SwiperRelatedProductsProps = {
  items: MainShopProduct[];
};

// اگه تعداد محصولات مرتبط کمتر یا مساوی این عدد باشه، به‌جای
// سوییپرِ اسکرول‌دار یه گرید می‌ذاریم که کارت‌ها به‌صورت درصدی
// از عرض رو پر می‌کنن و فضای خالی باقی نمی‌مونه.
const MAX_VISIBLE = 4;
const MIN_ITEM_WIDTH = 220;

export default function SwiperRelatedProducts({
  items,
}: SwiperRelatedProductsProps) {
  const ProductCard = loadThemeComponent("ProductCard");
  const useFluidGrid = items.length > 0 && items.length <= MAX_VISIBLE;

  if (useFluidGrid) {
    return (
      <div
        className="grid gap-4"
        style={{ gridTemplateColumns: `repeat(auto-fit, minmax(${MIN_ITEM_WIDTH}px, 1fr))` }}
      >
        {items.map((item) => (
          <ProductCard key={item.id} product={item} />
        ))}
      </div>
    );
  }

  return (
    <Swiper
      modules={[Scrollbar]}
      spaceBetween={16}
      slidesPerView="auto"
      scrollbar={{ draggable: true, dragSize: 500 }}
      className="w-full"
      style={{ paddingBottom: "70px" }}
    >
      {items.map((item) => (
        <SwiperSlide key={item.id} style={{ width: "300px" }}>
          <ProductCard product={item} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}